import React from 'react'

export function useForceUpdate() {
  const [_, setState] = React.useState(0)
  return () => setState((prev) => prev + 1)
}
